import React, { FC, useCallback, useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import { App } from '@capacitor/app';
import { Toast } from '@capacitor/toast';
import MobilePostListCompact from './MobilePostListCompact';
import { useMobileScrollHide } from './MobileHeaderContext';
import { PluginListenerHandle } from '@capacitor/core';

const MobileHomePage: FC = () => {
  useMobileScrollHide(true);
  const backPressRef = useRef(false);

  const handleBackButton = useCallback(() => {
    if (backPressRef.current) {
      App.exitApp();
    } else {
      backPressRef.current = true;
      Toast.show({ text: 'Press back again to exit' });
      setTimeout(() => {
        backPressRef.current = false;
      }, 2000);
    }
  }, []);

  useEffect(() => {
    let listener: PluginListenerHandle | null = null;
    const registerListener = async () => {
      listener = await App.addListener('backButton', handleBackButton);
    };
    registerListener();

    return () => {
      if (listener) {
        listener.remove();
      }
    };
  }, [handleBackButton]);

  // Full height: the feed renders swipeable tab panels that scroll internally.
  return (
    <Box sx={{ width: '100%', height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <MobilePostListCompact />
    </Box>
  );
};

export default MobileHomePage;